import styled, { css } from 'styled-components';

export const mobileFilterContainer = css`
  display: block;
  position: fixed;
  top: 0;
  overflow: scroll;
  left: 0;
  height: 100%;
  z-index: 1000;
  width: 100vw;
  padding: 120px 20px 20px 20px;
  background-color: #ffffff;
`;

export const MobileContainer = styled.div`
  ${mobileFilterContainer}
`;

export const MobileContainerHeader = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  padding: 27px 20px;
  display: flex;
  width: 100%;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);
  img {
    width: 20px;
    height: 20px;
    margin-left: 6px;
  }
  p {
    margin: 0px;
    text-align: right;
  }
`;
